export default __webpack_public_path__ + "static/media/flag_zh.fd0e8daf.svg";